import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

export function vpnBlockValidationSchema(messages) {
  return Yup.object().shape({
    name: Schemas.simpleStringSchema("Name", messages, true),
    size: Schemas.dropdownSchema("Size", messages, true),
    image: Schemas.dropdownSchema("Image", messages, true),

    // -- START - nasty WIRE GUARD HACK -- //

    // should be able to remove the then clause and just use otherwise.

    sitePublicIP: Yup.string().when("image", {
      is: value => {
        return (
          value === "/images/CbJ2JZr7-vRiH-je6x-rZcn-f0gUnialAGyg" || // AWS
          value === "/images/e4b95dbe-acdd-4fd8-894c-79d9f439538f" || // AWS 2
          value === "/images/7721a7ac-c82a-4293-893a-bc5639e8b231" || // AWS 3
          value === "/images/28afc343-94e9-45ae-93a8-bf41812df813" || // AWS - 18.2.7
          value === "/images/40c9d930-6af0-45c3-815d-027f1d258dea" || // AWS - Rocky 8.9
          value === "/images/370947af-9765-4fcb-93e2-5b273ecfc01b" || // AWS
          value === "/images/797330f3-32a5-435f-ab8f-4d20769eaaae" || // GCP - Centos
          value === "/images/1467bcb0-e07c-4f65-98f9-e6717b806b17" || // GCP 2 - Rocky
          value === "/images/d46cb380-8132-47d6-8fd3-22c552787484" || // GCP 3 - Rocky 8.8
          value === "/images/4fcafdaa-2d43-4de1-ad9b-76ecc57ca84f" || // GCP - 18.2.7
          value === "/images/392617f9-9bf8-477e-a88f-7578b3d4effd" || // GCP - Rocky 8.9
          value === "/images/2361024d-5d44-438e-a012-901a49829305" || // GCP
          value === "/images/d8e495ad-67d2-467c-8b8a-443f98d63157" || // Azure - Rocky 8.8
          value === "/images/9035b74a-c577-4c75-baf0-a0b639a1d03f" // Azure
        );
      },
      then: Yup.string(),
      otherwise: Schemas.ipSchema("Public IP", messages, true, false, true)
    }),
    siteSubnet: Yup.string().when("image", {
      is: value => {
        return (
          value === "/images/CbJ2JZr7-vRiH-je6x-rZcn-f0gUnialAGyg" || // AWS
          value === "/images/e4b95dbe-acdd-4fd8-894c-79d9f439538f" || // AWS 2
          value === "/images/7721a7ac-c82a-4293-893a-bc5639e8b231" || // AWS 3
          value === "/images/28afc343-94e9-45ae-93a8-bf41812df813" || // AWS - 18.2.7
          value === "/images/40c9d930-6af0-45c3-815d-027f1d258dea" || // AWS - Rocky 8.9
          value === "/images/370947af-9765-4fcb-93e2-5b273ecfc01b" || // AWS
          value === "/images/797330f3-32a5-435f-ab8f-4d20769eaaae" || // GCP - Centos
          value === "/images/1467bcb0-e07c-4f65-98f9-e6717b806b17" || // GCP 2 - Rocky
          value === "/images/d46cb380-8132-47d6-8fd3-22c552787484" || // GCP 3 - Rocky 8.8
          value === "/images/4fcafdaa-2d43-4de1-ad9b-76ecc57ca84f" || // GCP 3 - 18.2.7
          value === "/images/392617f9-9bf8-477e-a88f-7578b3d4effd" || // GCP - Rocky 8.9
          value === "/images/2361024d-5d44-438e-a012-901a49829305" || // GCP
          value === "/images/d8e495ad-67d2-467c-8b8a-443f98d63157" || // Azure - Rocky 8.8
          value === "/images/9035b74a-c577-4c75-baf0-a0b639a1d03f" // Azure
        );
      },
      then: Yup.string(),
      otherwise: Schemas.cidrSchema("Subnet", messages, true, true, false)
    })

    // -- END - nasty WIRE GUARD HACK -- //
  });
}
